'use client'
import { storyblokEditable } from '@storyblok/react'
import type { SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { root } from './SpacerBlock.css'

type SpaceSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl'

type Props = {
  size: SpaceSize
}

type SpacerBlockProps = SbBaseBlockProps<Props>

export const SpacerBlock = ({ blok }: SpacerBlockProps) => {
  return <div className={root} data-size={blok.size} {...storyblokEditable} />
}

SpacerBlock.blockName = 'spacer'
